// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e016486d","667":"e04b0acf"}[chunkId] + ".chunk.js";
};